<kiwi-area-competition-header></kiwi-area-competition-header>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-x align-center blockContent areaCompetition">
    <div *ngIf="area === 'working.class'" class="townImg _bad cell small-24"></div>

    <div *ngIf="area === 'average'" class="townImg _medium cell small-24"></div>

    <div *ngIf="area === 'wealthy'" class="townImg _good cell small-24"></div>

    <div class="cell small-24 grid-x grid-margin-x">
        <div *ngFor="let restaurantType of areaCompetition | keys" class="cell small-8">
        <kiwi-restaurant-type-rivals [restaurantType]="restaurantType"
                                     [rivals]="areaCompetition[restaurantType]"></kiwi-restaurant-type-rivals>
    </div>
    </div>
</div>
